import Action from 'actions';
import BaseLP from 'services/sports/default/base-lp';

export default class LpClassic extends BaseLP {
    createGroupsOfStacks({incomingValues: {dispatch}}) {
        const {
            playersData: {preparedPlayers},
        } = Action.getState();
        dispatch(Action.do('createGroupsOfPositionStacks', preparedPlayers.groupedBy.teamAndPosition()));
        dispatch(Action.do('createGroupsOfTeamStacks', preparedPlayers.groupedBy.property('team')));
    }

    // limitPositions({incomingValues = {}}) {
    //
    //     const sportConfig = Action.getState('sportConfig', {});
    //     const {teams = {}} = incomingValues;
    //
    //     let maxSingleTeamPlayers = sportConfig.getConfigProp('maxSingleTeamPlayers'),
    //         result = '';
    //
    //     if (maxSingleTeamPlayers) {
    //         Object.keys(teams).map(teamName => {
    //
    //             let str = '',
    //                 addedPlayers = [];
    //
    //             teams[teamName].map(player => {
    //
    //                 /**
    //                  * Avoid to add one player several time.
    //                  */
    //                 if (inArray(player.uniqueId, addedPlayers)) {
    //                     return;
    //                 }
    //
    //                 str += '+' + Const.LP_UNIT_PREFIX + player.uniqueId;
    //                 addedPlayers.push(player.uniqueId);
    //             });
    //
    //             if (str) {
    //                 result += str + '<=' + maxSingleTeamPlayers + "\n";
    //             }
    //         });
    //     }
    //
    //     return result;
    // }

    playerPositionStacking({incomingValues = {}}) {
        const {
            playerPositionStacking: stacking,
        } = Action.getState();

        return this.exec('keyPlayerStacking', {
            ...incomingValues,
            isOverlapPrimaryAndSecondaryStacksAllowed: stacking.isOverlapPrimaryAndSecondaryStacksAllowed(),
        });
    }

    subjectToPermanent() {
        const constraints = {
            players: this.exec(
                'player',
                {
                    checkIfPlayerOnDoublePosition: true,
                },
                '',
            ),
            salary: this.exec(
                'salary',
                {
                    checkIfPlayerOnDoublePosition: true,
                },
                '',
            ),
            projectedOwnershipCap: this.exec(
                'projectedOwnership',
                {
                    checkIfPlayerOnDoublePosition: true,
                },
                '',
            ),
            projectedOwnershipForce: this.exec(
                'forceOfProjectedOwnership',
                {
                    checkIfPlayerOnDoublePosition: true,
                },
                '',
            ),
            teams: this.exec(
                'team',
                {
                    checkIfPlayerOnDoublePosition: true,
                },
                '',
            ),
            minTeams: this.exec('minTeams', {}, ''),
            limitPositions: this.exec(
                'limitPositions',
                {
                    checkIfPlayerOnDoublePosition: true,
                },
                '',
            ),
            teamNameStacking: this.exec(
                'teamNameStacking',
                {
                    checkIfPlayerOnDoublePosition: true,
                },
                '',
            ),
            keyPlayerStacking: this.exec(
                'playerPositionStacking',
                {
                    checkIfPlayerOnDoublePosition: true,
                },
                '',
            ),
            passReceiver: this.exec(
                'passReceiver',
                {
                    checkIfPlayerOnDoublePosition: true,
                },
                '',
            ),
            projectionBoostRule: this.exec(
                'projectionBoostRule',
                {
                    checkIfPlayerOnDoublePosition: true,
                },
                '',
            ),
        };

        return {...constraints};
    }

    subjectToAlterable() {
        const constraints = {
            playersWhoseGamesAreLocked: this.exec(
                'playersWhoseGamesAreLocked',
                {
                    checkIfPlayerOnDoublePosition: true,
                },
                '',
            ),
            createdLineups: this.exec(
                'createdLineups',
                {
                    checkIfPlayerOnDoublePosition: true,
                },
                '',
            ),
            multiPositions: this.exec('multiPositions', {}, ''),
            exposureMax: this.exec(
                'exposureMax',
                {
                    checkIfPlayerOnDoublePosition: true,
                },
                '',
            ),
            exposureMin: this.exec(
                'exposureMin',
                {
                    checkIfPlayerOnDoublePosition: true,
                },
                '',
            ),
            flexExposureMax: this.exec(
                'flexMaxExposure',
                {
                    unitIdPropName: 'uniqueId',
                },
                '',
            ),
            correlationStackingPrimaryRule: this.exec(
                'correlationStackingPrimaryRule',
                {
                    checkIfPlayerOnDoublePosition: true,
                },
                '',
            ),
            correlationStackingSecondaryRule: this.exec(
                'correlationStackingSecondaryRule',
                {
                    checkIfPlayerOnDoublePosition: true,
                },
                '',
            ),
            correlationStackingUniversalRule: this.exec(
                'correlationStackingUniversalRule',
                {
                    checkIfPlayerOnDoublePosition: true,
                },
                '',
            ),
            correlationStackingRestrictedPlayers: this.exec(
                'correlationStackingRestrictedPlayers',
                {
                    checkIfPlayerOnDoublePosition: true,
                },
                '',
            ),
            keyPlayerStackingComboExpMax: this.exec(
                'keyPlayerStackingComboExpMax',
                {
                    checkIfPlayerOnDoublePosition: true,
                },
                '',
            ),
            playerCombinationStacking: this.exec(
                'playerCombinationStacking',
                {
                    checkIfPlayerOnDoublePosition: true,
                },
                '',
            ),
        };

        return {...constraints};
    }
}
